import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Button,
  ConfirmDialog,
  ErrorBlock,
  Heading,
  // SegmentedRadioButton,
} from "@simplecitizen/gdl-react-ui-components";
import BioGraphical from "./BioGraphical";
import CitizenShip from "./CitizenShip";
import StatusCategory from "./StatusCategory";
import { useAppSelector } from "src/hooks/redux-hooks";
import StatusType from "./StatusType";
import RequiredDocuments from "./RequiredDocuments";
import { cn } from "src/utils/tailwindMerger";
import { Checkbox } from "../checkbox/Checkbox";
import ContentWrapper from "../content-wrapper/ContentWrapper";
import { useForm} from "react-hook-form";
import { submitCheck, submitVevo } from "src/services/apiService";
import Vevo from "./Vevo";
import RequiredData from "./RequiredData";
import ExperianQuestions from './ExperianQuestions.tsx'
import { compareNames, findStatusType } from "src/utils/utils";
import Loader from "../loader/Loader.tsx";
import {useDispatch} from "react-redux";
// import {RegulaDocumentUpload} from "@simplecitizen/gdl-regula-components";
import EUCitizenShip from "./EUCitizenShip";
// import {clearIdDocs} from "../../../store/slices/identityDocCapture.ts";
// import {clearNonIdDocs} from "../../../store/slices/uploadedNonIdDocsSlice.ts";


export type Inputs = {
  firstName: string;
  middleName: string;
  lastName: string;
};

const QuestionnaireForm = ({
  scrollToNextPage,
  checkId,
}: {
  scrollToNextPage: () => void;
  checkId: string;
}) => {
  const {firstNameInDocument,lastNameInDocument} = useAppSelector(state => state.document_validation)
  const uploadedIdDocs = useAppSelector(
    (state) => state.identity_doc_capture.uploadedDocs
  );
  const [showDialog,setShowDialog] = useState(false)
  const [submissionError,setSubmissionError] = useState<null | string>(null)
  const firstNameRef =  useRef<HTMLDivElement>(null)
  const [experianFullAddress,setExperianFullAddress] = useState<any>(null)
  const [showAlmostDone, setShowAlmostDone] = useState(false);
  const uploadedNonIdDocs = useAppSelector((state) => state.non_id_docs.docs);
  const profile = useAppSelector((state) => state.profileData);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    trigger,
    setError,
  } = useForm<any>({
    mode: "onTouched",
    defaultValues: {
      firstName: profile.profile.name.firstName || "",
      middleName: profile.profile.name.middleName || "",
      lastName: profile.profile.name.lastName || "",
    },
  });

  const dispatch = useDispatch();

  const [selectedCitizenShip, setSelectedCitizenShip] = useState<
    "citizen" | "not_citizen" | null
  >(null);
  const [selectedEUCitizenShip, setSelectedEUCitizenShip] = useState<
    "eu_citizen" | "not_eu_citizen" | null
  >(null);
  const client = useAppSelector(
    (state) => state.questionnaire_data.questionnaire?.client
  );

  const [selectedStatusCategoryId, setSelectedStatusCategoryId] = useState<
    string | null
  >(null);

  const [selectedStatusTypeId, setSelectedStatusTypeId] = useState<
    string | null
  >(null);

  const statusCategories = useAppSelector(
    (state) =>
      state.questionnaire_data.questionnaire?.jurisdiction.statusCategories
  );
  const questionnaire_data = useAppSelector(
    (state: any) => state?.questionnaire_data?.questionnaire
  );
  const [selectedCategory, setSelectedCategory] =
    useState<StatusCategory | null>(null);

  const selectedStatusCategories = useMemo(() => {
    if (!statusCategories) return [];
    if (selectedCitizenShip === "citizen") {
      return statusCategories.filter((category) => category.isCitizenship);
    }
    if (
      selectedCitizenShip === "not_citizen"
    ) {
      if (selectedEUCitizenShip === "eu_citizen") {
        return statusCategories.filter((category) => category.isEUCitizenship);
      }
      if (selectedEUCitizenShip === "not_eu_citizen") {
        return statusCategories.filter((category) => !category.isEUCitizenship && !category.isCitizenship);
      }
      return [];
    }
    return statusCategories.filter((category) => !category.isCitizenship);
  }, [selectedCitizenShip, selectedEUCitizenShip, statusCategories]);

  const [selectedStatusType, setSelectedStatusType] =
    useState<StatusType | null>(null);

  // const [selectedWorkflow, setSelectedWorkflow] = useState<
  //     "passport" | "manual" | null
  // >(null);

  const [vevoCheck, setVevoCheck] = useState({});
  useEffect(() => {
    if(selectedStatusCategories?.length === 1) {
      setSelectedStatusCategoryId(selectedStatusCategories[0]?._id)
    }
    else
    {
      setSelectedStatusCategoryId(null)
    }
  }, [selectedStatusCategories]);

  useEffect(() => {
    if (selectedStatusCategoryId) {
      const category = statusCategories?.find(
        (category) => category._id === selectedStatusCategoryId
      );
      if (category) {
        setSelectedCategory(category);
      }
    }
  }, [selectedStatusCategoryId, statusCategories]);

  useEffect(() => {
    if (selectedStatusCategoryId) {
      if (selectedStatusTypeId) {
        const statusType = statusCategories
          ?.find((category) => category._id === selectedStatusCategoryId)
          ?.statusTypes.find(
            (statusType) => statusType._id === selectedStatusTypeId
          );
        if (statusType) {
          setSelectedStatusType(statusType);
        }
      } else {
        setSelectedStatusType(null);
      }
    }
  }, [selectedStatusCategoryId, statusCategories, selectedStatusTypeId]);

  const resetStates = () => {
    setSelectedCategory(null);
    setSelectedStatusCategoryId(null);
    setSelectedStatusType(null);
    setSelectedStatusTypeId(null);
  };

  // const resetVEVO = () => {
  //   setIsVevoDone(false)
  // };

  const citizenStategories = useMemo(() => {
    return statusCategories?.filter((category) => category.isCitizenship);
  }, [statusCategories]);

  const notCitizenCategories = useMemo(() => {
    return statusCategories?.filter((category) => !category.isCitizenship);
  }, [statusCategories]);
  const euCitizenCategories = useMemo(() => {
    return statusCategories?.filter((category) => category.isEUCitizenship);
  }, [statusCategories]);

  useEffect(() => {
    if (citizenStategories?.length === 0) {
      setSelectedCitizenShip("not_citizen");
    }
    if (notCitizenCategories?.length === 0) {
      setSelectedCitizenShip("citizen");
    }
  }, [citizenStategories, notCitizenCategories]);
  useEffect(() => {
    if (euCitizenCategories?.length === 0) {
      setSelectedEUCitizenShip("not_eu_citizen");
    }
  }, [euCitizenCategories]);

  const [showSubmit, setShowSubmit] = useState(false);
  const [isTermsAgreed, setIsTermsAgreed] = useState(false);

  const [documentCollectors, setDocumentCollectors] = useState<
    DocumentCollector[] | null
  >(selectedStatusType?.documentCollectors ?? null);
  const allUploadedDocs = useMemo(
    () => (uploadedIdDocs ?? []).concat(uploadedNonIdDocs),
    [uploadedIdDocs, uploadedNonIdDocs]
  );

  const uploadedRequiredDocs = useMemo(
    () => allUploadedDocs.filter((document: any) => document?.config?.required),
    [allUploadedDocs]
  );

  const requiredDocs = useMemo(() => {
    return selectedStatusType?.documentCollectors.filter(
      (document) => document.config.required
    );
  }, [selectedStatusType]);

    const documentStatus = useMemo(() => {
        const allDocs = (uploadedIdDocs ?? []).concat(uploadedNonIdDocs);
        const uploadedRequiredDocs = allDocs.filter((document: any) => document?.config?.required);
        const requiredDocs = selectedStatusType?.documentCollectors.filter(
            (document) => document.config.required
        ) ?? [];

        const hasRequiredDocs = requiredDocs.length > 0;
        const allRequiredDocsUploaded = uploadedRequiredDocs.length >= requiredDocs.length;

        return {
            allDocs,
            uploadedRequiredDocs,
            requiredDocs,
            hasRequiredDocs,
            allRequiredDocsUploaded,
            canSubmit: !hasRequiredDocs || allRequiredDocsUploaded
        };
    }, [uploadedIdDocs, uploadedNonIdDocs, selectedStatusType]);


    useEffect(() => {
    if (selectedStatusType) {
      setDocumentCollectors(selectedStatusType?.documentCollectors ?? null);
    }
  }, [selectedStatusType]);

  useEffect(() => {
    const allDocs = (uploadedIdDocs ?? []).concat(uploadedNonIdDocs);
    const uploadedRequiredDocs = allDocs.filter(
      (document: any) => document?.config?.required
    );
    const requiredDocs = selectedStatusType?.documentCollectors.filter(
      (document) => document.config.required
    );
    const isRequiredDocsUploaded =
      uploadedRequiredDocs.length >= (requiredDocs?.length ?? 0);

    if (selectedStatusType) {
      /// IF NO REQUIRED DOCUMENT, SHOW THE SUBMIT BUTTON
      if (requiredDocs?.length === 0) {
        setShowSubmit(true);
        return;
      }
      /// IF THERE'S REQUIRED DOCUMENTS AND THEY ARE ALL UPLOADED, SHOW THE SUBMIT BUTTON
      if (requiredDocs && isRequiredDocsUploaded ) {
        setShowSubmit(true);
        return;
      }
    }

    setShowSubmit(false);
  }, [selectedStatusType, requiredDocs, uploadedRequiredDocs, uploadedIdDocs, uploadedNonIdDocs]);

  const [submitting, setSubmitting] = useState(false);
  const isSubmittingRef = useRef(false);
  const [docsError, setDocsError] = useState<string | null>(null);
  const [isVevoDone, setIsVevoDone] = useState(false);
  const [isVevoRequired, setIsVevoRequired] = useState(false);
  const [vevoApiError, setVevoApiError] = useState<string | null>(null);
  const [isSubmittingVevo, setIsSubmittingVevo] = useState(false);

  // const [verificationData, setVerificationData] = useState<any>(null);

  // const [testingFields, setFields] = useState<any>(null);


  const selectVevoStatusType = (visaSubClass: string) => {
    const statusType = findStatusType(visaSubClass, selectedCategory?.statusTypes ?? []);


    if (statusType && visaSubClass) {
      setSelectedStatusType(statusType);
      setSelectedStatusTypeId(statusType._id);
   
    } else {
      setSelectedStatusType(selectedCategory?.statusTypes[0] ?? null)
      setSelectedStatusTypeId(selectedCategory?.statusTypes[0]._id ?? null)
    }
  };

  useEffect(() => {
    if (questionnaire_data) {
      if (
        questionnaire_data?.jurisdiction?.code2?.toUpperCase() !== "AU" &&
        questionnaire_data?.jurisdiction?.code3?.toUpperCase() !== "AUS" &&
        questionnaire_data?.jurisdiction?.name?.toUpperCase() !== "AUSTRALIA"
      ) {
        setIsVevoRequired(false);
        setIsVevoDone(true);
      }
    }
  }, [questionnaire_data]);

  useEffect(() => {
    if (questionnaire_data) {
      if (
        questionnaire_data?.jurisdiction?.code2?.toUpperCase() === "AU" ||
        questionnaire_data?.jurisdiction?.code3?.toUpperCase() === "AUS" ||
        questionnaire_data?.jurisdiction?.name?.toUpperCase() === "AUSTRALIA"
      ) {
        if (selectedCitizenShip === "not_citizen" && selectedCategory?.name.trim().toLowerCase() === 'Australian Visa Holder'.toLowerCase()) {
          setIsVevoRequired(true);
          setIsVevoDone(false);
        } else {
          setIsVevoRequired(false);
          setIsVevoDone(true);
        }
      }
    }
  }, [questionnaire_data, selectedCitizenShip,selectedCategory]);
  useEffect(() => {
      if (
        selectedCitizenShip &&
        (selectedCitizenShip === "citizen" || selectedEUCitizenShip) &&
        selectedStatusCategories?.length === 1
      ) {
        setSelectedStatusCategoryId(selectedStatusCategories[0]?._id);
      } else {
        setSelectedStatusCategoryId(null);
      }
      if (
        selectedCitizenShip &&
        selectedStatusCategories?.length === 1
      ) {
        setSelectedStatusCategoryId(selectedStatusCategories[0]?._id);
      } else {
        setSelectedStatusCategoryId(null);
      }
  }, [selectedStatusCategories, selectedCitizenShip, selectedEUCitizenShip, questionnaire_data]);


  const shouldShowSubmit = useMemo(() => {
    // Case 1: Regular submit - has status type and documents are ready
    if (selectedStatusType && documentStatus.canSubmit) {
      return true;
    }

    // Case 2: Special VEVO case - VEVO required, done, but no status type selected yet
    if (isVevoRequired && isVevoDone && !selectedStatusTypeId) {
      return true;
    }

    return false;
  }, [selectedStatusType, documentStatus.canSubmit, isVevoRequired, isVevoDone, selectedStatusTypeId]);


  const onSubmitVevo = async (vevoData: VevoType) => {
    setIsSubmittingVevo(true);
    setVevoApiError(null);
    try {
      const data = await submitVevo(vevoData, checkId);
      setVevoCheck(vevoData);

      if (data?.visaSubclass) {
        const visaSubClass = data?.visaSubclass;
        selectVevoStatusType(visaSubClass);
      } else {
        throw new Error("No visa subclass found for the provided details");
      }
      setIsVevoDone(true);
    } catch (error: any) {
      if (error?.errors) {
        const errorMessages = Object?.values(error?.errors)?.flatMap(
          (errorDetail: any) => Object?.values(errorDetail)
        );
        if (errorMessages.length > 0) {
          return setVevoApiError(errorMessages.join(", "));
        }
      }

      setVevoApiError(
        "WorkRight was not able to confirm your visa status in VEVO based on passport information provided. Please ensure that your full name in the Biographical Information section, as well as your passport number, issue country and date of birth are correct and try again. If you are still having issues, please contact us at WorkRight@fragomen.com"
      );
    } finally {
      setIsSubmittingVevo(false);
    }
  };

  const onSubmit = async (data: Inputs, isConfirm = false) => {
    setSubmissionError(null)
    if(selectedStatusType && selectedStatusType?.config?.experianAuthenticate){
      const isBuildingNameORBuildingNumberEmpty = !experianFullAddress['building name']?.trim() && !experianFullAddress['building number']?.trim()

      if(isBuildingNameORBuildingNumberEmpty){
        setError("googleResidentialAddress", { type: "custom", message: "Building Name or Building Number is required" });
        return
      }
    }

    if (!isConfirm) {
      if (firstNameInDocument && lastNameInDocument) {
        const nameComparisonParams: NameComparisonParams = {
          regulaGivenNames: firstNameInDocument ?? "",
          regulaLastName: lastNameInDocument ?? "",
          profileFirstName: data?.firstName ?? "",
          profileMiddleName: data?.middleName ?? "",
          profileLastName: data?.lastName ?? "",
        };

        const isMatch = compareNames(nameComparisonParams);

        if (!isMatch) {
          return setShowDialog(true);
        }
      }
    }

    const uploadedNonIdDocsIds = uploadedNonIdDocs
      ? uploadedNonIdDocs.map((doc: any) => ({
          [doc._id]: doc.doc_key,
        }))
      : [];

    const uploadedIdDocsIds = uploadedIdDocs
      ? uploadedIdDocs?.map((doc: any) => ({
          [doc._id]: doc.doc_key,
        }))
      : [];

    const docsToSendArray = uploadedNonIdDocsIds.concat(uploadedIdDocsIds);
    const docsToSend = docsToSendArray?.reduce(
      (acc: { [x: string]: any }, doc: { [x: string]: any }) => {
        acc = { ...acc, ...doc };
        return acc;
      },
      {}
    );

    if (shouldShowSubmit) {
      if (isSubmittingRef.current) return;
      isSubmittingRef.current = true;
      setSubmitting(true);
      setShowAlmostDone(false);
      const fullData = selectedStatusType?.config?.experianAuthenticate ? {
        ...data,
        ...vevoCheck,
        experianFirstName: data.firstName,
        experianLastName: data.lastName,
        primaryResidentialAddress: experianFullAddress,
      } : { ...data, ...vevoCheck }

      const timer = setTimeout(() => {
        setShowAlmostDone(true);
      }, 30000);

      try {
        const check_data = {
          statusCategoryId: selectedCategory?._id,
          statusTypeId: selectedStatusType?._id,
          ProfileName: {
            firstName: data.firstName,
            middleName: data.middleName,
            lastName: data.lastName,
          },
          documents: {
            ...docsToSend,
          },
          data: fullData ,
        };
        if (!documentStatus.allRequiredDocsUploaded && documentStatus.hasRequiredDocs) {
          setDocsError("Please upload all required documents");
          isSubmittingRef.current = false;
          setSubmitting(false);
          return;
        }
        setDocsError("");
        await submitCheck(checkId, check_data, dispatch);
        scrollToNextPage();
      } catch (error: unknown) {
                
          let message = "Something went wrong during submission.";

          if (error instanceof Error) {
            message = error.message;
          } else if (
            typeof error === "object" &&
            error !== null &&
            "response" in error &&
            typeof (error as any).response?.data?.message === "string"
          ) {
            message = (error as any).response.data.message;
          }

          setSubmissionError(message);
          console.error("Error Submitting Form", error);
     
      } finally {
        clearTimeout(timer);
        isSubmittingRef.current = false;
        setSubmitting(false);
      }
    }
  };

 const onConfirm = ()=> {
  setShowDialog(false)
  handleSubmit((data) => onSubmit(data, true))()

  }
  const closeDialog = ()=> {
    setShowDialog(false)
  }

  return (
    <>
      {showDialog && (
        <ConfirmDialog
          confirmButtonColor={client?.branding.primaryColor || "#0A71C7"}
          header="Name Mismatch Detected"
          message="There is a name mismatch which may effect the result of your RTW outcome, do you want to continue with submission without updating your profile?"
          confirmButtonText="Continue"
          cancelButtonText="Cancel"
          onConfirm={onConfirm}
          onCancel={closeDialog}
          onClose={closeDialog}
        />
      )}

      {submitting && (
        <div className="fixed top-0 left-0 w-screen h-screen bg-[rgba(0,0,0,0.7)] z-10 flex justify-center items-center">
          <div className="bg-white w-96 h-96 flex justify-center items-center rounded-lg overflow-hidden">
            <div className="flex flex-col justify-center items-center py-48">
              <div className="grid gap-3 mb-6">
                <Loader />
              </div>
              {showAlmostDone ? (
                <div className="text-black">
                  <Heading className="text-center">Almost done! Please keep this window open while we process your submission</Heading>
                </div>
              ) : (
                <div className="text-black">
                  <Heading className="text-center">Submitting...</Heading>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

    <form onSubmit={handleSubmit((data) => onSubmit(data, false))}>
      <ContentWrapper className="w-full pb-12 max-sm:px-4">
        <div ref={firstNameRef}>
        <BioGraphical control={control} errors={errors} />
        </div>
     
        {citizenStategories &&
          notCitizenCategories &&
          citizenStategories?.length > 0 &&
          notCitizenCategories?.length > 0 && (
            <CitizenShip
              resetStates={resetStates}
              setSelectedStatusType={setSelectedStatusType}
              setSelectedCategory={setSelectedCategory}
              selectedCitizenShip={selectedCitizenShip}
              setSelectedCitizenShip={setSelectedCitizenShip}
            />
          )}
          {selectedCitizenShip === "not_citizen" && euCitizenCategories && euCitizenCategories?.length > 0 && (
            <EUCitizenShip
              resetStates={resetStates}
              setSelectedStatusType={setSelectedStatusType}
              setSelectedCategory={setSelectedCategory}
              selectedEUCitizenShip={selectedEUCitizenShip}
              setSelectedEUCitizenShip={setSelectedEUCitizenShip}
            />
          )}
          <>
          {selectedCitizenShip && selectedEUCitizenShip && (
              <StatusCategory
                resetStates={resetStates}
                setSelectedStatusType={setSelectedStatusType}
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
                selectedCitizenShip={selectedCitizenShip}
                selectedEUCitizenShip={selectedEUCitizenShip}
                selectedStatusCategoryId={selectedStatusCategoryId}
                setSelectedStatusCategoryId={setSelectedStatusCategoryId}
              />
          )}

            {selectedCategory && isVevoDone && (
              <StatusType
                isVevoRequired={isVevoRequired}
                selectedStatusType={selectedStatusType}
                selectedCategory={selectedCategory}
                selectedStatusTypeId={selectedStatusTypeId}
                setSelectedStatusTypeId={setSelectedStatusTypeId}
              />
            )}

            {/*{ isVevoRequired &&*/}
            {/*  <div>*/}
            {/*    <div className="w-full mt-4">*/}
            {/*      <div className="mt-3">*/}
            {/*        <div>*/}
            {/*          <div className="font-semibold">*/}
            {/*            Please select preferred option for VEVO check validation*/}
            {/*          </div>*/}
            {/*          <div className="grid md:grid-cols-2 gap-2 w-full mt-4">*/}
            {/*            <SegmentedRadioButton*/}
            {/*                activeColor={client?.branding?.primaryColor || "#0A71C7"}*/}
            {/*                name="vevo"*/}
            {/*                id="upload passport"*/}
            {/*                value="passport"*/}
            {/*                selectedValue={selectedWorkflow}*/}
            {/*                onChange={(e) => {*/}
            {/*                  resetVEVO()*/}
            {/*                  dispatch(clearIdDocs());*/}
            {/*                  dispatch(clearNonIdDocs());*/}
            {/*                  setSelectedWorkflow*/}
            {/*                  (e.target.value as "passport");*/}
            {/*                }}*/}
            {/*            >*/}
            {/*              Upload Document*/}
            {/*            </SegmentedRadioButton>*/}
            {/*            <SegmentedRadioButton*/}
            {/*                name="vevo"*/}
            {/*                value="manual"*/}
            {/*                id="manual"*/}
            {/*                activeColor={client?.branding?.primaryColor || "#0A71C7"}*/}
            {/*                selectedValue={selectedWorkflow}*/}
            {/*                onChange={(e) => {*/}
            {/*                  resetVEVO()*/}
            {/*                  dispatch(clearIdDocs());*/}
            {/*                  dispatch(clearNonIdDocs());*/}
            {/*                  setSelectedWorkflow(e.target.value as "manual");*/}
            {/*                }}*/}
            {/*            >*/}
            {/*              Input Manually*/}
            {/*            </SegmentedRadioButton>*/}
            {/*          </div>*/}
            {/*        </div>*/}
            {/*      </div>*/}
            {/*    </div>*/}
            {/*  </div>*/}
            {/*}*/}

            {/*{*/}
            {/*  isVevoRequired && selectedWorkflow === "passport" &&*/}
            {/*    <div className="pt-5">*/}
            {/*      <RegulaDocumentUpload*/}
            {/*          regulaLicense={process.env.REACT_APP_REGULA_LICENSE_KEY}*/}
            {/*          onRemove={() => {*/}
            {/*            setFields(null);*/}
            {/*          }}*/}
            {/*          isVerifying={false}*/}
            {/*          color="red"*/}
            {/*          documentFields={testingFields}*/}
            {/*          validate={true}*/}
            {/*          forceSubmit={true}*/}
            {/*          onProcessedFinished={(fields: any) => {*/}
            {/*            setVerificationData(fields)*/}
            {/*          }}*/}
            {/*      />*/}
            {/*    </div>*/}
            {/*}*/}

            {/*For passport upload*/}
            {/*{questionnaire_data &&*/}
            {/*    selectedCitizenShip &&*/}
            {/*    selectedCitizenShip === "not_citizen" && verificationData &&*/}
            {/*    isVevoRequired && (*/}
            {/*        <Vevo*/}
            {/*            isVevoDone={isVevoDone}*/}
            {/*            vevoApiError={vevoApiError}*/}
            {/*            onSubmitVevo={onSubmitVevo}*/}
            {/*            isSubmittingVevo={isSubmittingVevo}*/}
            {/*            vevoData={verificationData}*/}
            {/*        />*/}
            {/*    )}*/}

            {/*For manual upload*/}
            {questionnaire_data &&
                selectedCitizenShip &&
                selectedCitizenShip === "not_citizen"
                // && selectedWorkflow === "manual"

                && isVevoRequired && (
                    <Vevo
                        isVevoDone={isVevoDone}
                        vevoApiError={vevoApiError}
                        onSubmitVevo={onSubmitVevo}
                        isSubmittingVevo={isSubmittingVevo}
                        vevoData={null}
                    />
                )}

            {selectedStatusType &&
                selectedStatusType?.dataCollectors.length > 0 && (
                    <RequiredData
                        errors={errors}
                        control={control}
                        register={register}
                        selectedStatusType={selectedStatusType}
                    />
                )}
            {selectedStatusType &&
                selectedStatusType?.config?.experianAuthenticate && (
                    <ExperianQuestions setExperianFullAddress={setExperianFullAddress} errors={errors}
                                       register={register} control={control}/>
                )}

            {selectedStatusType &&
              selectedStatusType?.documentCollectors.length > 0 && (
                <RequiredDocuments
                  trigger={trigger}
                  firstNameRef={firstNameRef}
                  control={control}
                  verificationData={null}
                  isVevoRequired={isVevoRequired}
                  documentCollectors={documentCollectors}
                  setDocumentCollectors={setDocumentCollectors}
                  selectedStatusType={selectedStatusType}
                  selectedWorkflow={null}
                />
              )}
          </>
      

        {(showSubmit ||
          (isVevoRequired && isVevoDone && !selectedStatusTypeId)) && (
          <>
            <div className="bg-gray-300 w-full h-[1px] my-8"></div>
            {
              (docsError || submissionError) &&  <ErrorBlock className="mb-2 flex fle-col">
                {
                  docsError && <div>{docsError}</div>
                }
                {
                  submissionError && <div>{submissionError}</div>
                }
              </ErrorBlock>
            }
         
            <div>
              <div
                style={{
                  boxShadow: "0px 0px 0px 0.2px rgb(0 0 0 / 0.2)",
                }}
                className="relative px-6 py-6 text-sm rounded-xl"
              >
                <div
                  style={{
                    backgroundColor: client?.branding.primaryColor || "#0A71C7",
                    boxShadow: "0px 0px 0px 0.2px rgb(0 0 0 / 0.2)",
                    borderColor: client?.branding.primaryColor || "#0A71C7",
                    borderWidth: "2px",
                    borderStyle: "solid",
                  }}
                  className={cn(
                    "opacity-[0.1] absolute top-0 right-0 h-full w-full rounded-xl "
                  )}
                ></div>
                <div>
                  The above information is true and accurate to the best of your
                  knowledge. Any misrepresentation to your work status may
                  result in a delay of confirming your right to work and if you
                  have not already started work, may result in a delay to
                  starting your role.
                </div>
                <div className="mt-4">
                  <Checkbox
                    checked={isTermsAgreed}
                    onChange={() => {
                      setIsTermsAgreed(!isTermsAgreed);
                    }}
                    label={"I agree to the above"}
                  />
                </div>
              </div>

              <Button
                disabled={!isTermsAgreed || submitting}
                color={client?.branding.primaryColor || "#0A71C7"}
                className="mt-8 w-full"
                type="submit"
              >
                {"Submit Response"}
              </Button>
            </div>
          </>
        )}
      </ContentWrapper>
    </form>
    </>
  );
};

export default QuestionnaireForm;